module.exports = __webpack_public_path__ + "assets/img/f7f73a1cb6e8d9d86850be8bd39ccf32.svg";